namespace TabAurous.Retail {
    export namespace ExchangeForReceiptService {
        export const baseUrl = 'Exchange/ExchangeForReceipt';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ExchangeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Exchange/ExchangeForReceipt/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ExchangeForReceiptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
